import React from 'react';

const DashLine = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="2" viewBox="0 0 40 2">
    <line
      id="Line_28"
      x1="40"
      transform="translate(0 1)"
      fill="none"
      stroke={props.stroke}
      strokeWidth="2"
      strokeDasharray="10 6"
    />
  </svg>
);
export default DashLine;



// WEBPACK FOOTER //
// ./src/img/ComponentAsImage/DashLine.js